<mh-core-lib-loader-wrapper
    class="tw-h-96"
    [type]="'spinner'"
    [loading]="loading"
    className="tw-self-center" 
    spinnerClassName="tw-text-[50px]">
        <div class="tw-flex tw-justify-end">
            <i class="far fa-times tw-cursor-pointer" (click)="close()"></i>
        </div>
        <div class="tw-p-4 tw-max-h-[100%] tw-overflow-auto">
            <table class="tw-w-full tw-mt-2">
                <tr class="tw-border-b">
                    <th class="tw-pb-6">{{ 'commons.permission' | translate }}</th>
                    @for (role of roles; track roleTrack($index, role)) {
                        <th class="tw-pb-6 tw-text-center">{{ 'models.user_profile.roles.' + role.id | translate }}</th>
                    }
                </tr>

                @for (action of actions; track action) {
                    <tr class="tw-border-b">
                        <td class="tw-py-2">
                            <div class="tw-flex tw-flex-col tw-justify-center">
                                <p class="tw-font-bold">{{ action.title }} {{ action.subTitle }}</p>
                            </div>
                        </td>
                        @for (role of roles; track roleTrack($index, role)) {
                            <td class="tw-py-2">
                                @if (action[role.name] === 'active') {
                                    <div class="tw-flex tw-justify-center">
                                        <img class="tw-text-center tw-align-middle" src="https://statics.myhotel.cl/uploads/fidelity-suite/user-manager/check.png"/>
                                    </div>
                                }
                            </td>
                        }
                    </tr>
                }
            </table>
        </div>
</mh-core-lib-loader-wrapper>
